import React from 'react';
import invoiceImage from './../../../../../../../statics/img/halan/invoice_image.jpg';
import { CONSTANTS } from '../../constants';

export default function Invoice({ orderAmount, plan }) {
  const months = plan && plan.months;
  const amount =
    plan && plan.amount.toLocaleString('en-US', { minimumFractionDigits: 2 });
  const adminFees =
    plan &&
    plan.adminFees.toLocaleString('en-US', {
      minimumFractionDigits: 2,
    });

  return (
    <div className="halan_invoice">
      <img className="halan_invoice_image" src={invoiceImage} alt="invoice" />
      {plan && (
        <div className="halan_invoice_content">
          <div>
            <p>{CONSTANTS.INVOICE.ORDER}</p>
            <h3>EGP {orderAmount}</h3>
          </div>
          <div>
            <p>{CONSTANTS.INVOICE.FINANCE}</p>
            <p>EGP {orderAmount}</p>
          </div>
          <div>
            <p>{CONSTANTS.INVOICE.INSTALLMENT}</p>
            <p>
              EGP {amount} per month / {months} months
            </p>
          </div>
          {!!(plan && plan.adminFees) && (
            <div>
              <p>{CONSTANTS.INVOICE.ADMIN}</p>
              <p>EGP {adminFees}</p>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
